import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { datadogRum } from '@datadog/browser-rum';

function initializeDatadogRum() {
  try {
    datadogRum.init({
      applicationId: '97967b77-9783-4b5b-bccb-8785af8138d6',
      clientToken: 'pub3cf5973492d008696245a7ba07b1f721',
      site: 'datadoghq.com',
      service: 'dn-portal-client-nursing',
      env: environment.dd_env_name ?? 'unknown',
      sessionSampleRate: 100,
      sessionReplaySampleRate: 20,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: 'mask-user-input',
    });
    datadogRum.startSessionReplayRecording();
  } catch (error) {
    console.error('Failed to initialize Datadog RUM:', error);
  }
}

if (environment.production) {
  enableProdMode();
  initializeDatadogRum();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));

